/**
 * This class represents Map wrapper
 */

import Helper from "../Helper";

export default class MapWrapper {
  /**
   * Constructor of map popup
   */
    constructor()
    {
        this.name = "map_modal";
        this.mapModal = $('[data-map-wrapper="map_modal"]');
        this.scrollablePart = $('[data-scrollablepart="map_modal"]');
        this.notScrollableElements = $('[data-notscrollable="map_modal"]');
        this.mapWrapper = $('[data-mapwrapper="map_modal"]');
        this.scrollableHeight = 0;
        this.mapHeight = 0;
        this.isOpened = false;

        this.init();
    }

    init()
    {
        $(document).ready(() => {
          /**
           * On window resize update init height
           */
            window.windowResizeObserve.register(() => {
                this.reset();
            });


            $('[data-target="'+this.name+'"]').click(() => {
                this.open();
            })

            $('[data-close="'+this.name+'"]').click(() => {
                this.close();
            })
        });
    }

  /**
   * Function that opens the popup
   */
    open()
    {
        this.isOpened = true;

        window.map.setZoom(13);
        this.mapModal.show();

        this.setScrollableHeight();
        this.setMapHeight();

        this.scrollablePart.css({
            'height': this.scrollableHeight + 'px'
        })

        this.mapWrapper.css({
            'height' : this.mapHeight + 'px'
        });
    }

  /**
   * Function that resets the popup
   */
    reset()
    {
        if (this.isOpened) {
            this.setScrollableHeight();
            this.setMapHeight();

            this.scrollablePart.css({
                'height': this.scrollableHeight + 'px'
            })

            this.mapWrapper.css({
                'height' : this.mapHeight + 'px'
            });
        }
    }

  /**
   * Function that closes the popup
   */
    close()
    {
        this.mapModal.hide();
        $('body').css({
            'overflow': 'scroll'
        });

        this.isOpened = false;
    }

  /**
   * Function that sets scrollable part height
   */
    setScrollableHeight()
    {
        let height = 0;

        this.notScrollableElements.each((i, e) => {
            height += $(e).outerHeight();
        })

        this.scrollableHeight = window.innerHeight - height;
    }

  /**
   * Function that set map height
   */
    setMapHeight()
    {
      // 90 - offset top, 20 - offset bottom
        this.mapHeight = window.innerHeight - 90 - 20;
    }

  /**
   * Function that shows map on responsive devices on masonry pages
   *
   * @param {Element | null} e clicked button
   * @param {Boolean} show true if show map, false if hide
   */
    showHideMapMasonry(e, show)
    {
        if (e !== null) {
            $(e).hide();
        } else {
            $('[data-showlistbutton]').hide();
        }

        let map = $('[data-mapcolumn]');

        if (show) {
            $(map).css({
                'visibility': 'visible'
            });

            $('[data-showlistbutton]').show();
            $('body').css('overflow', 'hidden');
            $('[data-showmapbuttonwrapper]').css('z-index', '1002');
        } else {
            $('[data-showmapbutton]').show();
            $(map).css({
                'visibility': 'hidden'
            });
            $('body').css('overflow', 'scroll');
            $('[data-showmapbuttonwrapper]').css('z-index', '996');
        }
    }
}
